/**
 * Static data actions
 * @namespace static_data_actions
 * @category Redux
 * @subcategory Actions
 */
// eslint-disable-next-line
const static_data_actions = {};
//used for the namespace in the documentation

/**
 * Static data charges action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setChargersStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setChargersStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_CHARGERS", payload: value });
  };
};
/**
 * Static data cycleways action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setCyclewaysStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setCyclewaysStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_CYCLEWAYS", payload: value });
  };
};

//kanachkova
/**
 * Static data temporary reconstructions action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setReconstructionsTemporaryStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
 export const setReconstructionsTemporaryStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_RECONSTRUCTIONS_TEMPORARY", payload: value });
  };
};


//kanachkova
/**
 * Static data permanent reconstructions action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setReconstructionsPermanentStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setReconstructionsPermanentStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_RECONSTRUCTIONS_PERMANENT", payload: value });
  };
};


/**
 * Static data green corridors action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setGreenCorridor1StaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setGreenCorridor1StaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_GREEN_CORRIDOR_ONE", payload: value });
  };
};
/**
 * Static data green corridors action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setGreenCorridor2StaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setGreenCorridor2StaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_GREEN_CORRIDOR_TWO", payload: value });
  };
};
/**
 * Static data green corridors action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setGreenCorridor3StaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setGreenCorridor3StaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_GREEN_CORRIDOR_THREE", payload: value });
  };
};
/**
 * Static data subway stations action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setSubwayStationsStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setSubwayStationsStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_SUBWAY_STATIONS", payload: value });
  };
};
/**
 * Static data subway lines action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setSubwayLinesStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setSubwayLinesStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_SUBWAY_LINES", payload: value });
  };
};
/**
 * Static data trams action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setTMStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setTMStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_TM", payload: value });
  };
};
/**
 * Static data trolleys and ebuses action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setTBStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setTBStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_TB", payload: value });
  };
};
/**
 * Static data buses action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setTStaticData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setBStaticData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_DATA_B", payload: value });
  };
};
/**
 * Static filtered data trams action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setTMStaticFilteredData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setTMStaticFilteredData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_FILTERED_DATA_TM", payload: value });
  };
};
/**
 * Static filtered data trolleys and ebuses action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setTBStaticFilteredData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setTBStaticFilteredData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_FILTERED_DATA_TB", payload: value });
  };
};
/**
 * Static filtered data buses action
 * @category Redux
 * @subcategory Actions
 * @memberof static_data_actions
 * @function setBStaticFilteredData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setBStaticFilteredData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_STATIC_FILTERED_DATA_B", payload: value });
  };
};
